// ===========================
// Authentication Action Types
// ===========================
export const AUTH_INITIALIZED = 'AUTH_INITIALIZED';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGOUT = 'LOGOUT';

// ===========================
// Ad Management Action Types
// ===========================
export const FETCH_ADLIST_REQUEST = 'FETCH_ADLIST_REQUEST';
export const FETCH_ADLIST_SUCCESS = 'FETCH_ADLIST_SUCCESS';
export const FETCH_ADLIST_FAIL = 'FETCH_ADLIST_FAIL';

export const CREATE_AD_REQUEST = 'CREATE_AD_REQUEST';
export const CREATE_AD_SUCCESS = 'CREATE_AD_SUCCESS';
export const CREATE_AD_FAIL = 'CREATE_AD_FAIL';

export const UPDATE_AD_REQUEST = 'UPDATE_AD_REQUEST';
export const UPDATE_AD_SUCCESS = 'UPDATE_AD_SUCCESS';
export const UPDATE_AD_FAIL = 'UPDATE_AD_FAIL';

export const DELETE_AD_REQUEST = 'DELETE_AD_REQUEST';
export const DELETE_AD_SUCCESS = 'DELETE_AD_SUCCESS';
export const DELETE_AD_FAIL = 'DELETE_AD_FAIL';

// ===========================
// Placement Action Types
// ===========================
export const FETCH_PLACEMENTS_REQUEST = 'FETCH_PLACEMENTS_REQUEST';
export const FETCH_PLACEMENTS_SUCCESS = 'FETCH_PLACEMENTS_SUCCESS';
export const FETCH_PLACEMENTS_FAIL = 'FETCH_PLACEMENTS_FAIL';

export const CREATE_PLACEMENT_REQUEST = 'CREATE_PLACEMENT_REQUEST';
export const CREATE_PLACEMENT_SUCCESS = 'CREATE_PLACEMENT_SUCCESS';
export const CREATE_PLACEMENT_FAIL = 'CREATE_PLACEMENT_FAIL';

export const UPDATE_PLACEMENT_REQUEST = 'UPDATE_PLACEMENT_REQUEST';
export const UPDATE_PLACEMENT_SUCCESS = 'UPDATE_PLACEMENT_SUCCESS';
export const UPDATE_PLACEMENT_FAIL = 'UPDATE_PLACEMENT_FAIL';

export const DELETE_PLACEMENT_REQUEST = 'DELETE_PLACEMENT_REQUEST';
export const DELETE_PLACEMENT_SUCCESS = 'DELETE_PLACEMENT_SUCCESS';
export const DELETE_PLACEMENT_FAIL = 'DELETE_PLACEMENT_FAIL';

// ===========================
// Settings Action Types
// ===========================
export const FETCH_SETTINGS_REQUEST = 'FETCH_SETTINGS_REQUEST';
export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS';
export const FETCH_SETTINGS_FAIL = 'FETCH_SETTINGS_FAIL';

export const SAVE_SETTINGS_REQUEST = 'SAVE_SETTINGS_REQUEST';
export const SAVE_SETTINGS_SUCCESS = 'SAVE_SETTINGS_SUCCESS';
export const SAVE_SETTINGS_FAIL = 'SAVE_SETTINGS_FAIL';

// ===========================
// API Keys Action Types
// ===========================
export const FETCH_API_KEYS_REQUEST = 'FETCH_API_KEYS_REQUEST';
export const FETCH_API_KEYS_SUCCESS = 'FETCH_API_KEYS_SUCCESS';
export const FETCH_API_KEYS_FAIL = 'FETCH_API_KEYS_FAIL';

export const CREATE_API_KEY_REQUEST = 'CREATE_API_KEY_REQUEST';
export const CREATE_API_KEY_SUCCESS = 'CREATE_API_KEY_SUCCESS';
export const CREATE_API_KEY_FAIL = 'CREATE_API_KEY_FAIL';

export const REVOKE_API_KEY_REQUEST = 'REVOKE_API_KEY_REQUEST';
export const REVOKE_API_KEY_SUCCESS = 'REVOKE_API_KEY_SUCCESS';
export const REVOKE_API_KEY_FAIL = 'REVOKE_API_KEY_FAIL';

export const CLEAR_NEWLY_CREATED_KEY = 'CLEAR_NEWLY_CREATED_KEY';

